module.exports = require("rc-calendar/lib/locale/zh_CN");


//////////////////
// WEBPACK FOOTER
// external "rc-calendar/lib/locale/zh_CN"
// module id = 130
// module chunks = 0